/** The hub on its tile: the pad and its glowing ring. */
import { KIND, type Kind } from '@bramvasterd/terrella-rules';
import type * as THREE from 'three';

import type { Instances } from './instances';

/** The hub on tile `i` at direction `c`. Returns false for other kinds. */
export function placeHub(ins: Instances, c: THREE.Vector3, kind: Kind): boolean {
  if (kind !== KIND.HUB) return false;
  ins.put('hub.pad', c, 0, 0, 0, 1);
  ins.put('hub.ring', c, 0, 0, 0, 1);
  return true;
}
